export default class PathsMap {
    constructor() {
        this.pathNodes = new Map();
    }

    getData(key) {
        if (this.pathNodes.has(key)) {
            return this.pathNodes.get(key);
        }

        return undefined;
    }

    getKeys() {
        return this.pathNodes.keys();
    }

    setData(key, value) {
        if (this.pathNodes.has(key)) {
            const oldValue = this.pathNodes.get(key);
            // do not override a value when has_children is true, children are already set and the "new" value's children are undefined or empty
            // this can happen when concurrent fetching leads to the last-level-node of a chunk
            // overriding the first-level-node of the next chunk that came early
            // or when the breadcrumb-based entries are re-added due to structural overlap
            if (oldValue.has_children && oldValue.children.length && (value.has_children === undefined || value.children.length === 0)) {
                console.log('OPT OUT!');
                return;
            }
        }
        // set key-value-pair if the value is not undefined or false
        if (value) this.pathNodes.set(key, value);
    }
}
